import {fetchLocationMetrics, fetchMHELocationMetrics} from "../../induct/network/InductNetworkAPI";

export const ASL_INDUCT_AREA_ACTIONS = {
    MHE_INDUCT_AREA_INSIGHT: "MHE_INDUCT_AREA_INSIGHT"
}

export const ASLInductAreaReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {filter, dispatcher} = action.data;
            fetchLocationMetrics(dispatcher);
            fetchMHELocationMetrics(filter, dispatcher);
            return state
        case "INDUCT_AREA_INSIGHT":
            const inductAreaMap = getInductAreaMap(action.data.inductAreaData);
            return {...state, inductAreaMap};
        case ASL_INDUCT_AREA_ACTIONS.MHE_INDUCT_AREA_INSIGHT:
            const mheInductAreaMap = getMHEInductAreaMap(action.data.mheInductAreaData);
            return {...state, mheInductAreaMap};
        default:
            return state
    }
}

const getInductAreaMap = (inductAreaData) => {
    const inductAreas = inductAreaData.map(inductAreaInsight => ({
        [inductAreaInsight.locationName]: {
            inductRate: inductAreaInsight.inductRate,
            volumeInducted: inductAreaInsight.volumeInducted,
            inductTimeoutCount: inductAreaInsight.inductTimeoutCount,
            inductFailedVerificationCount: inductAreaInsight.inductFailedVerificationCount,
            sidelineCount: inductAreaInsight.sidelineCount,
        }
    }))
    return Object.assign({}, ...inductAreas);
}

const getMHEInductAreaMap = (inductAreaData) => {
    const inductAreas = inductAreaData.map(inductAreaInsight => ({
        [inductAreaInsight.locationName]: {
            maxPPH: inductAreaInsight.maxPPH,
            noRead: inductAreaInsight.noRead,
            verificationFailure: inductAreaInsight.verificationFailure,
            total: inductAreaInsight.total,
            success: inductAreaInsight.success,
            kickout: inductAreaInsight.kickout,
        }
    }))
    return Object.assign({}, ...inductAreas);
}



// WEBPACK FOOTER //
// ./src/components/technician/reducer/ASLInductAreaReducer.js